<template>
  <consult-contact-panel
    :title="headerText"
    :subtitle="subtitle"
    date-placeholder="请选择日期（预测日期为一年内）"
    :day-placeholder="dayPlaceholder"
    :show-use-days="showUseDays"
    submit-button-text="开始查询"
    :address-required="true"
    dialog-width="800px"
    future-date-message="开放日期必须大于当前日期（最大为30天）"
    :initial-contact="initialContact"
    @back="goBack"
    @submit="onSubmit"
  />
</template>

<script>
import ConsultContactPanel from "./widgets/ConsultContactPanel.vue";

export default {
  components: { ConsultContactPanel },
  data() {
    return {
      serviceIndex: 1,
      headerText: "智能查询",
      subtitle: "为患者提供专业的健康服务查询",
      dayPlaceholder: "请输入使用天数",
      showUseDays: true,
      initialContact: null
    };
  },
  created() {
    this.serviceIndex = +this.$route.query.serviceIndex;
    const hideDays = this.serviceIndex == 3 || this.serviceIndex == 4 || this.serviceIndex == 12;
    this.showUseDays = !hideDays;
    switch (this.serviceIndex) {
      case 1:
        document.title = "健康指引"; this.headerText = "健康指引";
        this.dayPlaceholder = "请输入健康持续天数"; this.subtitle = "预测患者未来一段时间的健康趋势"; break;
      case 2:
        document.title = "本草茶饮"; this.headerText = "本草茶饮";
        this.dayPlaceholder = "请输入本草茶饮持续天数"; this.subtitle = "为患者定制本草茶饮用方案"; break;
      case 3:
        document.title = "经络调理"; this.headerText = "经络调理";
        this.subtitle = "制定个性化经络调理方案"; break;
      case 4:
        document.title = "针灸"; this.headerText = "针灸";
        this.subtitle = "安排针灸调理计划"; break;
      case 5:
        document.title = "本草压片"; this.headerText = "本草压片";
        this.dayPlaceholder = "请输入本草压片持续天数"; this.subtitle = "为本草压片服用制定方案"; break;
      case 9:
        document.title = "私人定制养生茶"; this.headerText = "私人定制养生茶";
        this.dayPlaceholder = "请输入私人定制养生茶持续天数"; this.subtitle = "私人定制养生茶方案"; break;
      case 11:
        document.title = "六气汤"; this.headerText = "六气汤";
        this.dayPlaceholder = "请输入六气汤持续天数"; this.subtitle = "六气汤服用方案"; break;
      case 12:
        document.title = "新健康指引"; this.headerText = "新健康指引";
        this.subtitle = "新健康指引服务"; break;
    }
  },
  mounted() {
    const contact = sessionStorage.getItem("selectContact");
    if (contact != null && contact.length > 0) {
      this.initialContact = JSON.parse(contact);
      sessionStorage.removeItem("selectContact");
    }
  },
  methods: {
    goBack() {
      if (!this.utils.isEmptyStr(this.fromPath) && this.fromPath != "/") this.$router.go(-1);
      else this.$router.replace("/");
    },
    onSubmit(payload) {
      sessionStorage.setItem("serviceInfo", JSON.stringify({
        patientId: payload.selectContact.patientId,
        useDate: payload.useDate,
        useDays: payload.useDays,
        serviceIndex: this.serviceIndex
      }));
      this.$router.push("/serviceResult");
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => { vm.fromPath = from.path; });
  }
};
</script>
